import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { ReactComponent as Illustration } from "../../../../../assets/illustrations/CalculatorIllustration.svg";
import { ReactComponent as Arrow } from "../../../../../assets/arrow-right.svg";
import { CalculatorContext } from "../../../../app";
import { sumOFBills } from "../../../../sumOfBillsCalculator";
import { sumOfRecoveryBill } from "../../../../sumOfRecoveryBill";
import { sumOfOwnerBill } from "../../../../sumOfOwnerBill";
import { formatter } from "../../../../../common/number-format";

export default function MainBottomFrame() {
  const { utilities } = React.useContext(CalculatorContext);
  const classes = useStyles();

  const finalBills = sumOFBills(utilities);
  const recoveryBill = sumOfRecoveryBill(utilities);
  const yourBill = sumOfOwnerBill(utilities);

  return (
    <Grid container item xs={12} className={classes.bottomContainer}>
      <Grid item container xs={3}>
        <Illustration className={classes.illustration} />
      </Grid>
      <Grid item container xs={9} className={classes.rightContainer}>
        {Object.keys(utilities).map((title, index) => {
          if (utilities[title] !== "")
            return (
              <Grid
                item
                className={classes.utilityBillsContainer}
                key={index}
                style={
                  utilities[title].isEnabled
                    ? null
                    : { opacity: "0.2", zIndex: "1" }
                }
              >
                <Grid item container className={classes.finalBills}>
                  <Typography variant="h6" style={{ fontSize: "13px", lineHeight: "19.5px" }}>
                    {title} bill: {formatter.format(utilities[title].BTV)}
                  </Typography>
                </Grid>
                <Grid item container className={classes.arrow}>
                  <Typography variant="h6">
                    <Arrow />
                  </Typography>
                </Grid>

                <Grid
                  item
                  container
                  style={{
                    width: "90%",
                    display: "contents",
                  }}
                >
                  <Grid
                    item
                    container
                    className={classes.billBarGreen}
                    style={
                      utilities[title].BTV === 0
                        ? {
                            width: "0px",
                          }
                        : {
                            width: `${(utilities[title].ATP / finalBills) * 100}%`,
                          }
                    }

                    // style={{
                    //   width: `${(utilities[title].ATP / finalBills) * 100}%`,
                    // }}
                  >
                    <Typography variant="h6" className={classes.billBarText}>
                      {formatter.format(utilities[title].ATP)}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    container
                    style={
                      utilities[title].BTV === 0
                        ? {
                            width: "10px",
                          }
                        : {
                            width: `${
                              ((utilities[title].BTV - utilities[title].ATP) /
                                finalBills) *
                              100
                            }%`,
                          }
                    }
                    className={classes.blackBillBar}
                  >
                    <Typography variant="h6"></Typography>
                  </Grid>
                  <Grid item container className={classes.utilityOwnerPay}>
                    <Typography variant="h6" style={{ fontSize: "15px" }}>
                      {formatter.format(
                        utilities[title].BTV - utilities[title].ATP
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          return null;
        })}

        <Grid item className={classes.bottomBarsContainer}>
          <CalculatorContext.Provider value={finalBills}>
            <Grid item container className={classes.finalBillsLastBar}>
              <Typography
                variant="h6"
                style={{
                  fontSize: "18px",
                  lineHeight: "27px",
                }}
              >
                Your Bills: {formatter.format(finalBills)}
              </Typography>
            </Grid>
            <Grid item container className={classes.arrowLastBar}>
              <Typography variant="h6">
                <Arrow
                  style={{
                    width: "10px",
                    height: "20px",
                  }}
                />
              </Typography>
            </Grid>
            <Grid
              item
              container
              style={
                recoveryBill === 0
                  ? {
                      width: "200px",
                    }
                  : {
                      width: "130%",
                    }
              }
              className={classes.billBarGreenLastBar}
            >
              <Typography variant="h6" className={classes.billBarText}>
                Recover {formatter.format(recoveryBill.toFixed(2))}!
              </Typography>
            </Grid>
            <Grid
              item
              container
              style={
                recoveryBill === 0
                  ? {
                      width: "163px",
                    }
                  : {
                      width: "35%",
                    }
              }
              className={classes.blackBillBarLastBar}
            >
              <Typography
                variant="h6"
                className={classes.billBarBlackText}
              >
                You pay {formatter.format(yourBill)}
              </Typography>
            </Grid>
          </CalculatorContext.Provider>
        </Grid>
      </Grid>
    </Grid>
  );
}
